export default __webpack_public_path__ + "images/db565f1077dca05bef5bb66b45029ba4-emoji-content.svg";